// extracted by mini-css-extract-plugin
export default {"noteCard":"NoteCard_noteCard__8miXT","link_img":"NoteCard_link_img__kCS2o"};